import {
    getObjects,
    createObjects,
    updateObjects,
    deleteObjects
} from './../api/webApplicationApi';
import { v4 as uuidv4 } from 'uuid';

const objectType = 'account';

export class Account {
    private _saveMethod = createObjects;
    private _object: omAccount;
    private _lastError: Error;

    public constructor(accountID: string) {
        this._object = {
            accountID: accountID,
            name: undefined,
            ownerUserID: undefined,
            organizationID: undefined,
            binID: undefined,
        };
    }

    public static createNew(): Account {
        return new Account(uuidv4());
    }

    public static createFromObject(account: omAccount): Account {
        const obj = new Account(account.accountID);
        obj._object = account;
        obj._saveMethod = updateObjects;
        return obj;
    }

    public async load(): Promise<boolean> {
        const getObject: GetRequest = {
            objectType: objectType,
            keys: [this._object.accountID],
        };
        this._lastError = undefined;
        try {
            const response = await getObjects([getObject]);
            if (
                response &&
                response.length > 0 &&
                response[0].objects &&
                response[0].objects.length == 1
            ) {
                this._saveMethod = updateObjects;
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('account not found');
                return false;
            }
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public async save(): Promise<boolean> {
        const saveObject: CreateUpdateDeleteRequest = {
            objectType: objectType,
            object: this._object,
        };
        this._lastError = undefined;

        if (this._object.name == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        if (this._object.organizationID == undefined) {
            this._lastError = new Error('Organization ID is undefined');
            return false;
        }
        if (this._object.ownerUserID == undefined) {
            this._lastError = new Error('Owner User ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([saveObject]);
            if (response) {
                this._saveMethod = updateObjects;
            } else {
                this._lastError = new Error('unknow server error');
            }
            return response;
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public async delete(): Promise<boolean> {
        const deleteObject: CreateUpdateDeleteRequest = {
            objectType: objectType,
            object: this._object,
        };
        this._lastError = undefined;
        try {
            const response = await deleteObjects([deleteObject]);
            return response;
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public get lastError(): Error {
        return this._lastError;
    }

    public get accountID(): string {
        return this._object.accountID;
    }

    public get binID(): string {
        return this._object.binID;
    }

    public set binID(binID: string) {
        this._object.binID = binID;
    }

    public get name(): string {
        return this._object.name;
    }

    public set name(name: string) {
        this._object.name = name;
    }

    public get organizationID(): string {
        return this._object.organizationID;
    }

    public set organizationID(organizationID: string) {
        this._object.organizationID = organizationID;
    }

    public get ownerUserID(): string {
        return this._object.ownerUserID;
    }

    public set ownerUserID(ownerUserID: string) {
        this._object.ownerUserID = ownerUserID;
    }
}
